import { translation } from "@/configurations/i18n"
import { useTranslation } from "react-i18next"

export const useGaAttribute = () => {
  const { t } = useTranslation()

  const setGaAttribute = (value: string) => {
    switch (value) {
      case t(translation.header.introductionToNDC):
        return {
          ["data-action"]: "true",
          ["data-event"]: "maingnb_about_ndc",
          ["data-value"]: "gnb_about_ndc",
          ["data-label"]: "GNB - NDC 소개 클릭 수"
        }
      case t(translation.header.faq):
        return {
          ["data-action"]: "true",
          ["data-event"]: "maingnb_faq",
          ["data-value"]: "gnb_faq",
          ["data-label"]: "GNB -자주 묻는 질문 클릭 수"
        }
      case t(translation.header.session):
        return {
          ["data-action"]: "true",
          ["data-event"]: "maingnb_session",
          ["data-value"]: "gnb_session",
          ["data-label"]: "GNB - 세션 클릭 수"
        }
      case t(translation.header.onlineStreaming):
        return {
          ["data-action"]: "true",
          ["data-event"]: "maingnb_online",
          ["data-value"]: "gnb_online",
          ["data-label"]: "GNB - 온라인 생중계 클릭 수"
        }
      default:
        return {}
    }
  }

  return { setGaAttribute }
}
